import type { SxProps, Theme } from '@mui/material';

export const getTabStyle = (tabName: string, value: string, theme: Theme): SxProps<Theme> => ({
  backgroundColor: value === tabName ? theme.palette.white.main : theme.palette.grey[200],
  color: value === tabName ? theme.palette.text.primary : theme.palette.grey[600],
  fontWeight: value === tabName ? 'bold' : 'normal',
  borderRadius: 0,
  boxShadow: 'none',
  textTransform: 'none',
  textWrap: 'wrap',
  flex: 1,
  fontSize: '14px',
  '&:hover': {
    backgroundColor:
      value === tabName ? `${theme.palette.white.main} !important` : theme.palette.grey[300],
    borderColor: theme.palette.divider,
    color: value === tabName ? theme.palette.text.primary : theme.palette.grey[600],
  },
  '&:focus': {
    backgroundColor: value === tabName ? theme.palette.white.main : theme.palette.grey[200],
    outline: 'none',
  },
  '&:active': {
    backgroundColor: value === tabName ? theme.palette.white.main : theme.palette.grey[400],
  },
});
